import { createColumnHelper } from "@tanstack/react-table";
import { dateFormatter } from "../../../utils/dateFormatter";
const columnHelper = createColumnHelper();

export const refundTableColumnsConfig = {
  refund: (handleOpenModal) => [
    columnHelper.accessor("id", {
      header: "ID",
      cell: (info) => info.getValue(),
      footer: (props) => props.column.id,
    }),
    columnHelper.accessor("order_id", {
      header: "Order Id",
      cell: (info) => info.getValue(),
      footer: (props) => props.column.id,
    }),
    columnHelper.accessor("delivered_on", {
      header: "Delivered On",
      cell: (info) => dateFormatter(info.getValue()),
      footer: (props) => props.column.id,
    }),
    columnHelper.accessor("postal_code", {
      header: "PinCode",
      cell: (info) => info.getValue(),
      footer: (props) => props.column.id,
    }),
    columnHelper.accessor("status", {
      header: "Status",
      cell: (info) => info.getValue(),
      footer: (props) => props.column.id,
    }),
    columnHelper.accessor("price", {
      header: "Total Amount",
      cell: (info) => info.getValue(),
      footer: (props) => props.column.id,
    }),

    columnHelper.display({
      id: "actions",
      header: <div style={{ textAlign: "center" }}>Action</div>,
      cell: (props) => (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <button
            disabled={props.row.original.status !== "Refund Requested"}
            style={{
              color:
                props.row.original.status !== "Refund Requested"
                  ? "#B0B0B0"
                  : "#46CD80",
              fontSize: "12px",
              lineHeight: "12px",
              fontWeight: 500,
              fontFamily: "Poppins, sans",
              padding: "8px",
              border: "none",
              cursor:
                props.row.original.status !== "Refund Requested"
                  ? "not-allowed"
                  : "pointer",
            }}
            onClick={() => handleOpenModal(props.row.original, "Approve")}
          >
            Approve
          </button>
          |
          <button
            disabled={props.row.original.status !== "Refund Requested"}
            style={{
              color:
                props.row.original.status !== "Refund Requested"
                  ? "#B0B0B0"
                  : "#FE0000",
              fontSize: "14px",
              lineHeight: "14px",
              fontWeight: 500,
              fontFamily: "Poppins, sans",
              padding: "8px",
              border: "none",
              cursor:
                props.row.original.status !== "Refund Requested"
                  ? "not-allowed"
                  : "pointer",
            }}
            onClick={() => handleOpenModal(props.row.original, "Reject")}
          >
            Reject
          </button>
        </div>
      ),
    }),
  ],
};
